import React, { useState } from 'react';
import { Tooltip, IconButton } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PropTypes from 'prop-types';

const CopyToClipboardButton = ({ valueToCopy, iconStyle = {} }) => {
  const [tooltipText, setTooltipText] = useState('Copy');

  const handleCopy = () => {
    navigator.clipboard
      .writeText(valueToCopy)
      .then(() => {
        setTooltipText('Copied!');
        setTimeout(() => setTooltipText('Copy'), 2000);
      })
      .catch(() => {
        setTooltipText('Failed');
      });
  };

  return (
    <Tooltip title={tooltipText}>
      <IconButton style={iconStyle} onClick={handleCopy}>
        <ContentCopyIcon />
      </IconButton>
    </Tooltip>
  );
};

CopyToClipboardButton.propTypes = {
  valueToCopy: PropTypes.string.isRequired,
  iconStyle: PropTypes.object.isRequired
};

export default CopyToClipboardButton;
